import React, { useState, useEffect } from 'react';
import QuizTimer from '../QuizTimer';
import { observable } from 'legacy-packages/ft-cb';
import './styles.scss';

/**
 * Draws the mobile timer
 * */
const MobileTimer = (props) => {
  const {
    timerInfo,
    isSoftTime,
    onShowModal,
    timer,
    checkTimeExtension,
    checkTimeExtensionInterval,
    onTimerExpiring,
    learnosityData,
  } = props;
  const [subscribedProps, setSubscribedProps] = useState(timerInfo);

  useEffect(() => {
    const callback = (value) => {
      setSubscribedProps(value);
    };
    observable.subscribe('timerInfo', callback);

    return () => {
      observable.unsubscribe('timerInfo', callback);
    };
  }, []);

  return (
    <div className="MobileTimer--container">
      {timerInfo && (
        <QuizTimer
          hasControls
          timerInfo={subscribedProps}
          isSoftTime={isSoftTime}
          onShowModal={onShowModal}
          timer={timer}
          checkTimeExtension={checkTimeExtension}
          checkTimeExtensionInterval={checkTimeExtensionInterval}
          onTimerExpiring={onTimerExpiring}
          learnosityData={learnosityData}
        />
      )}
    </div>
  );
};

MobileTimer.displayName = 'MobileTimer';

export default MobileTimer;
